<template>
  <div>
    <!--货物明细（委托）-->
    <div class="section" style="flex: 1;">
      <span class="title">{{ $t('Warehouse.CargoDetails') + '(' + this.$t('CargoMsg.Cargo_Consignation') + ')' }}</span>
      <div class="form-row grid-list">
        <el-form
          label-width="100px"
          label-position="left"
          :disabled="!isEditing"
          style="margin-right:10px"
        >
          <div>
            <el-form class="spacing" style="margin-bottom: 8px">
              <el-radio-group v-model="jobGoodsViewType">
                <el-radio label="detail">{{ $t('Warehouse.Detail') }}</el-radio>
                <el-radio label="summary">{{ $t('Warehouse.Summary') }}</el-radio>
              </el-radio-group>
            </el-form>
            <el-form class="spacing" style="margin-bottom: 8px">
              <el-button v-if="!jobGoodsViewSummary && editPermission" type="primary" :disabled="!isEditing" @click="addDetailEstHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
              <el-dropdown
                v-if="editPermission"
                no="exportOrderHandle"
                split-button
                type="primary"
                :disabled="hasChecklistTime || isEditing"
                style="margin:0 5px"
                @click="exportOrderHandle()"
                @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
              >
                <span v-if="exportOrderCommand === this.$t('CargoMsg.Cargo_DownloadTemplate')">{{ exportOrderCommand }}</span>
                <el-upload
                  v-if="[$t('SeaExport.BatchImport'), $t('SeaExport.GoodsInformationImport')].includes(exportOrderCommand)"
                  :action="URL.fba.batchImport"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{uuid:jobUuid}"
                  style="display: inline-block; margin-left: 5px"
                >
                  <span style="color: white">{{ [$t('SeaExport.BatchImport'), $t('SeaExport.GoodsInformationImport')].includes(exportOrderCommand) ? exportOrderCommand : '' }}</span>
                </el-upload>
                <el-dropdown-menu slot="dropdown" :style="{minWidth: $selectByLang('80px', '80px', '80px', '140px', '140px', '140px')}">
                  <el-dropdown-item :command="$t('SeaExport.GoodsInformationImport')">
                    <el-upload
                      ref="uploadOrder"
                      :action="URL.fba.batchImport"
                      :headers="headers"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-success="uploadOrderSuccess"
                      :on-error="handleError"
                      :data="{uuid:jobUuid}"
                      style="display: inline-block"
                    >
                      <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('SeaExport.GoodsInformationImport') }}</el-button>
                    </el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.GoodsInformationImport')">
                    <el-button no="16" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadDetail()">{{ $t('CargoMsg.Cargo_DownLoad_Detail') }}</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.GoodsInformationImport')">
                    <el-button no="16" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadSummary()">{{ $t('CargoMsg.Cargo_DownLoad_Summary') }}</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button v-if="editPermission" type="primary" :disabled="!isEditing" @click="batchMaintenanceEst">{{ $t('Warehouse.BatchMaintenance') }}</el-button>
              <el-button v-if="editPermission" type="danger" :disabled="!isEditing || hasChecklistTime" @click="clearDataEst">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
              <el-button v-if="editPermission" type="danger" :disabled="!isEditing" @click="delDetailEstHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
            </el-form>
            <cargo-ag-grid
              v-if="!jobGoodsViewSummary"
              ref="goodsDetailTableEst"
              config-module="9300021"
              :grid-options="detailList.goodGridOptionsEst"
              :column-defs="dynamicGoodsColumnEstDefs"
              :row-data="form.fbaJobGoods || []"
              style="height: 200px"
              @gridReady="params=>{detailList.gridApiEst=params.api}"
            />
            <cargo-ag-grid
              v-if="jobGoodsViewSummary"
              ref="goodsSummaryTableEst"
              config-module="9300022"
              :grid-options="detailList.goodGridOptionsEst"
              :column-defs="dynamicGoodsColumnEstDefs"
              :row-data="summaryJobGoodsDetailList || []"
              style="height: 200px"
              @gridReady="params=>{detailList.gridApiEst=params.api}"
            />
            <el-form-item class="auto-width">
              <div style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:100px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;">{{ $t('SeaExport.Weight2') }} KGS</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.Cubage') }} CBM</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.VolumetricWeight') }} KGS</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }} M/T</div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignation')" class="auto-width">
              <input
                v-model="form.quantityContract"
                disabled
                :style="{color: Number(form.quantitySum) === Number(form.quantityContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.weightContract"
                disabled
                :style="{color: Number(form.weightSum) === Number(form.weightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.cubageContract"
                disabled
                :style="{color: Number(form.cubageSum) === Number(form.cubageContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.volumetricWeightContract"
                disabled
                :style="{color: Number(form.volumetricWeightAct) === Number(form.volumetricWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.chargeWeightContract"
                :disabled="!isEditing"
                :style="{color: Number(form.chargeWeightAct) === Number(form.chargeWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                @change="changeChargeWeightContract"
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!--货物明细（实际）-->
    <div class="section" style="flex: 1;">
      <span class="title">{{ $t('Warehouse.CargoDetails') + '(' + this.$t('SeaExport.Actual') + ')' }}</span>
      <div class="form-row grid-list">
        <el-form
          label-width="100px"
          label-position="left"
          :disabled="!isEditing"
          style="margin-right:10px"
        >
          <div>
            <el-form class="spacing" style="margin-bottom: 8px">
              <el-radio-group v-model="goodsViewType">
                <el-radio label="detail">{{ $t('Warehouse.Detail') }}</el-radio>
                <el-radio label="summary">{{ $t('Warehouse.Summary') }}</el-radio>
              </el-radio-group>
            </el-form>
            <el-form class="spacing" style="margin-bottom: 8px">
              <el-button v-if="!goodsViewSummary && editPermission" type="primary" :disabled="!isEditing || hasChecklistTime" @click="addDetailHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
              <el-button v-if="editPermission" type="primary" :disabled="!isEditing || hasChecklistTime" @click="batchMaintenance">{{ $t('Warehouse.BatchMaintenance') }}</el-button>
              <el-dropdown
                v-if="editPermission"
                no="14"
                style="margin:0 5px;font-size: 12px"
              >
                <el-upload
                  :action="actionOrderUrl"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{uuid:jobUuid,type:'SE'}"
                  style="display: inline-block; margin-left: 5px"
                  :disabled="hasChecklistTime || isEditing"
                >
                  <el-button type="primary" :disabled="hasChecklistTime || isEditing">
                    {{ $t('CargoMsg.Cargo_Import2') }}
                    <i class="el-icon-arrow-down el-icon--right" />
                  </el-button>
                </el-upload>
                <el-dropdown-menu slot="dropdown" :style="{minWidth: $selectByLang('80px', '80px', '80px', '140px', '140px', '140px')}">
                  <el-dropdown-item :command="1">
                    <el-upload
                      ref="uploadOrder"
                      :action="actionOrderUrl"
                      :headers="headers"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-success="uploadOrderSuccess"
                      :on-error="handleError"
                      :data="{uuid:jobUuid, type:'SE'}"
                      style="display: inline-block"
                    >
                      <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('CargoMsg.GOODS_INFO_IMPORT') }}</el-button>
                    </el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button no="16" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadDetail()">{{ $t('CargoMsg.Cargo_DownLoad_Detail') }}</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button no="17" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadSummary()">{{ $t('CargoMsg.Cargo_DownLoad_Summary') }}</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button v-if="editPermission" type="primary" :disabled="isEditing || !(form.warehouseInDetailList && form.warehouseInDetailList.length > 0)" @click="onCheckList()">{{ $t('Warehouse.Checklist') }}</el-button>
              <el-button v-if="editPermission" type="primary" :disabled="!isEditing || hasChecklistTime" @click="pickingGoods">{{ $t('Warehouse.PickingGoods') }}</el-button>
              <el-button v-if="editPermission" type="danger" :disabled="!isEditing || hasChecklistTime" @click="clearData">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
              <el-button v-if="editPermission" type="danger" :disabled="!isEditing || hasChecklistTime" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
            </el-form>
            <el-form :disabled="hasChecklistTime">
              <cargo-ag-grid
                v-if="!goodsViewSummary"
                ref="goodsDetailTable"
                config-module="9300023"
                :grid-options="detailList.goodGridOptions"
                :column-defs="dynamicGoodsColumnDefs"
                :row-data="form.warehouseInDetailList || []"
                style="height: 200px"
                @gridReady="params=>{detailList.gridApi=params.api}"
              />
              <cargo-ag-grid
                v-if="goodsViewSummary"
                ref="goodsSummaryDTable"
                config-module="9300024"
                :grid-options="detailList.goodGridOptions"
                :column-defs="dynamicGoodsColumnDefs"
                :row-data="summaryGoodsDetailList || []"
                style="height: 200px"
                @gridReady="params=>{detailList.gridApi=params.api}"
              />
            </el-form>
            <el-form-item class="auto-width">
              <div style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:100px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;">{{ $t('SeaExport.Weight2') }} KGS</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.Cubage') }} CBM</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;">{{ $t('SeaExport.VolumetricWeight') }} KGS</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }} M/T</div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Actual')" class="auto-width">
              <input
                v-model="form.quantitySum"
                disabled
                :style="{color: Number(form.quantitySum) === Number(form.quantityContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.weightSum"
                disabled
                :style="{color: Number(form.weightSum) === Number(form.weightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.cubageSum"
                disabled
                :style="{color: Number(form.cubageSum) === Number(form.cubageContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.volumetricWeightAct"
                disabled
                :style="{color: Number(form.volumetricWeightAct) === Number(form.volumetricWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
              >
              <input
                v-model="form.chargeWeightAct"
                :disabled="!isEditing"
                :style="{color: Number(form.chargeWeightAct) === Number(form.chargeWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                @change="changeChargeWeightAct"
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 核单 -->
    <el-dialog
      v-if="checklist.visible"
      v-el-drag-dialog
      :visible.sync="checklist.visible"
      :title="$t('Warehouse.Checklist')"
      width="340px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Warehouse.ChecklistTime')">
          <el-date-picker v-model="checklist.checklistTime" no="checklistTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:195px" :placeholder="$t('SeaExport.SelectTime')" />
        </el-form-item>
        <el-form-item :label="$t('Warehouse.ChecklistResult')">
          <el-select v-model="checklist.checklistStatus" no="checklistStatus" style="width:195px;" placeholder="">
            <el-option
              v-for="item in SystemConstants.CHECKLIST_STATUS"
              :key="item.code"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Warehouse.HandlingOpinions')">
          <el-input v-model="checklist.comments" type="textarea" :row="5" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="toChecklist">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="checklist.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量维护弹窗 -->
    <batch-maintenance-dialog
      v-if="batchMaintenanceDialog.visible"
      :visible.sync="batchMaintenanceDialog.visible"
      :job-key="jobUuid"
      :exist-detail-list="batchMaintenanceDialog.est ? form.fbaJobGoods : form.warehouseInDetailList"
      @saveCallBack="batchMaintenanceDialog.saveCallBack"
      @close="batchMaintenanceDialog.visible=false"
    />
    <!-- 货箱编号编辑弹窗 -->
    <container-no-editor
      v-if="containerNoEditor.visible"
      :boxes-number="containerNoEditor.boxesNumber"
      :visible.sync="containerNoEditor.visible"
      :shipment-id="containerNoEditor.shipmentId"
      :source="containerNoEditor.source"
      :container-no="containerNoEditor.containerNo"
      :warehouse-in-detail-list="containerNoEditor.detailList"
      @summarySaveCallBack="containerNoEditor.summarySaveCallBack"
      @detailSaveCallBack="containerNoEditor.detailSaveCallBack"
      @close="containerNoEditor.visible=false"
    />
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { FbaWarehouseInDetail } from '@/class/model/booking/FbaWarehouseInDetail'
import { fbaSeaExportChecklist, loadFbaExportWarehouseInRelated } from '@/api/warehouseIn/warehouseIn'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ContainerNoEditor from '@/views/cargo/v0/FBA/ContainerNoEditor'
import BatchMaintenanceDialog from '@/views/cargo/v0/FBA/batchMaintenanceDialog'
import { TabError } from '@/utils/class/TabError'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import { searchCustomerPrice } from '@/api/price/fbaQuotation'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'

export default {
  name: 'TabWarehousingDetail',
  components: {
    ContainerNoEditor,
    BatchMaintenanceDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    source: { type: String, required: false, default: () => '' },
    warehouseInUuid: { type: String, default: () => '' },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isUppercaseByConfig: { type: Boolean, default: true }
  },
  data() {
    return {
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      URL,
      jobUuid: '',
      job: {},
      ready: false,
      mawbDoc: new AirCargoDoc().fillDefaultValue().getData(),
      bubbleCountingRatio: 0.0,
      SystemConstants,
      editPermission: false,
      goodsViewType: 'detail',
      jobGoodsViewType: 'detail',
      exportOrderCommand: this.$t('SeaExport.BatchImport'),
      form: new WarehouseIn().fillDefaultValue().getData(),
      // 货物明细（委托）汇总数据
      summaryJobGoodsDetailList: [],
      // 货物明细（实际）汇总数据
      summaryGoodsDetailList: [],
      // 货物明细（委托）汇总数据与明细数据关联关系对象，key为汇总条件json
      summaryAndDetailGoodsRelEst: {},
      // 货物明细（实际）汇总数据与明细数据关联关系对象，key为汇总条件json
      summaryAndDetailGoodsRel: {},
      // 删除货物明细（委托）
      delWarehouseInDetailKeysEst: [],
      // 删除货物明细
      delWarehouseInDetailKeys: [],
      detailList: {
        gridApiEst: null,
        goodGridOptionsEst: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptionsEst.selectedRowIndex = event.rowIndex
            if (this.jobGoodsViewSummary) {
              this.onSummaryContainerNoCellFocused(event, true)
            } else {
              this.onDetailContainerNoCellFocused(event, true)
            }
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsDetailColumnEst: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 140
          },
          {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 120,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 120,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          },
          {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Electric'), field: 'electric', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Magnetic'), field: 'magnetic', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Powdery'), field: 'powdery', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Liquid'), field: 'liquid', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          }
        ],
        goodsSummaryColumnEst: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 140
          },
          {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 120,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 120,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxesNumber', current, warehouseInDetailList)
            }
          },
          {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
              this.detailList.goodGridOptions.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Electric'), field: 'electric', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Magnetic'), field: 'magnetic', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Powdery'), field: 'powdery', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          { headerName: this.$t('FbaJob.Liquid'), field: 'liquid', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          },
          {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params, true)
            }
          }
        ],
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
            if (this.goodsViewSummary) {
              this.onSummaryContainerNoCellFocused(event)
            } else {
              this.onDetailContainerNoCellFocused(event)
            }
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsDetailColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxesNumber', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxLength', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxWidth', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxHeight', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.palletContainerNum'), field: 'palletContainerNum', colId: 'palletContainerNum', minWidth: 150,
            valueFormatter: params => {
              return params.data.palletUuid ? 1 : 0
            }
          }, {
            headerName: this.$t('Warehouse.otherContainerNum'), field: 'otherContainerNum', colId: 'otherContainerNum', minWidth: 150,
            valueFormatter: params => {
              return params.data.palletUuid ? 0 : 1
            }
          }
        ],
        goodsSummaryColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxesNumber', current, fbaJobGoods)
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'), field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'), field: 'cargoEnglishName', colId: 'cargoEnglishName', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'), field: 'cargoChineseName', colId: 'cargoChineseName', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'), field: 'materialQuality', colId: 'materialQuality', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'), field: 'productDescription', colId: 'productDescription', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.palletContainerNum'), field: 'palletContainerNum', colId: 'palletContainerNum', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.otherContainerNum'), field: 'otherContainerNum', colId: 'otherContainerNum', minWidth: 150
          }
        ]
      },
      batchMaintenanceDialog: {
        visible: false,
        est: false,
        saveCallBack: (detailList) => {
          this.calcSingleVolumetricWeightAndChargeWeight(detailList, this.batchMaintenanceDialog.est)
          if (this.batchMaintenanceDialog.est) {
            this.form.fbaJobGoods = this.form.fbaJobGoods.concat(detailList)
            this.calcEstJmt()
            this.genSummaryJobGoodsDetailList()
          } else {
            this.form.warehouseInDetailList = this.form.warehouseInDetailList.concat(detailList)
            this.calcActJmt()
            this.genSummaryGoodsDetailList()
          }
        }
      },
      containerNoEditor: {
        est: false,
        visible: false,
        shipmentId: '',
        boxesNumber: 0,
        key: '',
        containerNo: '',
        source: '',
        detailList: [],
        summarySaveCallBack: (result) => {
          const { startSeq, boxSeqLen, containerNo } = result
          const key = this.containerNoEditor.key
          const summaryGoodsDetailList = []
          // 更新箱货信息-汇总
          const updatedList = this.containerNoEditor.est ? this.summaryJobGoodsDetailList : this.summaryGoodsDetailList
          updatedList.forEach(summaryGoodsDetail => {
            if (summaryGoodsDetail.key === key) {
              summaryGoodsDetail.containerNo = containerNo
            }
            summaryGoodsDetailList.push(summaryGoodsDetail)
          })
          if (this.containerNoEditor.est) {
            this.summaryJobGoodsDetailList = summaryGoodsDetailList
          } else {
            this.summaryGoodsDetailList = summaryGoodsDetailList
          }
          // 更新箱货信息-明细
          let index = Number(startSeq)
          const relList = this.containerNoEditor.est ? this.summaryAndDetailGoodsRelEst : this.summaryAndDetailGoodsRel
          relList[key].forEach(goodsDetail => {
            goodsDetail.containerNo = this.containerNoEditor.shipmentId + index.toString().padStart(boxSeqLen, '0')
            goodsDetail.updated = true
            index++
          })
        },
        detailSaveCallBack: (result) => {
          const { containerNo } = result
          const goodsDetailList = []
          const updatedList = this.containerNoEditor.est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
          updatedList.forEach(goodsDetail => {
            const key = goodsDetail.uuid ? goodsDetail.uuid : goodsDetail.tmpUuid
            if (key === this.containerNoEditor.key) {
              goodsDetail.containerNo = containerNo
              goodsDetail.updated = true
            }
            goodsDetailList.push(goodsDetail)
          })
          if (this.containerNoEditor.est) {
            this.form.fbaJobGoods = goodsDetailList
            this.genSummaryJobGoodsDetailList()
          } else {
            this.form.warehouseInDetailList = goodsDetailList
            this.genSummaryGoodsDetailList()
          }
        }
      },
      // 核单
      checklist: {
        visible: false,
        checklistTime: '',
        comments: '',
        checklistStatus: 1
      }
    }
  },
  computed: {
    fbaLob() {
      return this.source === 'fbaSea' || this.source === 'fbaAir' || this.source === 'fbaRailway'
    },
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    goodsViewSummary() {
      return this.goodsViewType === 'summary'
    },
    jobGoodsViewSummary() {
      return this.jobGoodsViewType === 'summary'
    },
    dynamicGoodsColumnDefs() {
      let columnDef = []
      if (this.goodsViewSummary) {
        columnDef = this.detailList.goodsSummaryColumn
      } else {
        columnDef = this.detailList.goodsDetailColumn
      }
      return columnDef
    },
    dynamicGoodsColumnEstDefs() {
      let columnDef = []
      if (this.jobGoodsViewSummary) {
        columnDef = this.detailList.goodsSummaryColumnEst
      } else {
        columnDef = this.detailList.goodsDetailColumnEst
      }
      return columnDef
    },
    hasChecklistTime() {
      return this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0 && !!this.form.warehouseInDetailList[0].checklistTime
    },
    actionOrderUrl() {
      return URL.fba.fbaBatchImportOnOrder
    }
  },
  watch: {
    'job.fbaJob.bubbleCountingRatio'(newVal, oldVal) {
      this.bubbleCountingRatio = Number(newVal)
      if (this.ready) {
        // 委托
        this.form.volumetricWeightContract = (((Number(this.form.cubageContract) * 1000000) / Number(this.bubbleCountingRatio))).toFixed(3)
        this.form.chargeWeightContract = Number(this.form.weightContract) > Number(this.form.volumetricWeightContract) ? this.form.weightContract : this.form.volumetricWeightContract
        switch (this.source) {
          case 'fbaAir':
            this.job.chargeWeight = Number(this.form.weightContract) > Number(this.form.volumetricWeightContract) ? Number(this.form.weightContract) : Number(this.form.volumetricWeightContract)
            this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
            this.job.chargeWeightBooking = this.job.chargeWeight
            this.job.volumetricWeightBooking = this.job.volumetricWeightContract
            break
          case 'fbaRailway':
            break
        }
        // 实际
        this.form.volumetricWeightAct = (((Number(this.form.cubageSum) * 1000000) / Number(this.bubbleCountingRatio))).toFixed(3)
        this.form.chargeWeightAct = Number(this.form.weightSum) > Number(this.form.volumetricWeightAct) ? this.form.weightSum : this.form.volumetricWeightAct
        this.job.volumetricWeight = Number(this.form.volumetricWeightAct)
        switch (this.source) {
          case 'fbaSea':
            this.job.chargeWeight = Number(this.form.weightSum) > Number(this.form.volumetricWeightAct) ? Number(this.form.weightSum) : Number(this.form.volumetricWeightAct)
            break
          case 'fbaAir':
            this.job.cWeight = Number(this.form.weightSum) > Number(this.form.volumetricWeightAct) ? Number(this.form.weightSum) : Number(this.form.volumetricWeightAct)
            this.mawbDoc.cWeight = this.job.cWeight
            this.mawbDoc.volumetricWeight = this.job.volumetricWeight
            break
          case 'fbaRailway':
            this.job.chargeWeight = Number(this.form.weightSum) > Number(this.form.volumetricWeightAct) ? Number(this.form.weightSum) : Number(this.form.volumetricWeightAct)
            break
        }
        this.chargeWeightRelateVarChange()
      }
    },
    'job.fbaJob.serviceChannel'(newVal, oldVal) {
      if (this.ready) {
        this.chargeWeightRelateVarChange()
      }
    },
    'job.fbaJob.chargingMethod'(newVal, oldVal) {
      if (this.ready) {
        this.chargeWeightRelateVarChange()
      }
    },
    'job.fbaJob.warehouseCode'(newVal, oldVal) {
      if (this.ready) {
        this.chargeWeightRelateVarChange()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 根据业务加载货物信息
    getWarehouse(row) {
      const params = {}
      params.jobUuid = row.uuid
      if (row.fbaJob) {
        if (row.fbaJob.bubbleCountingRatio || typeof row.fbaJob.bubbleCountingRatio === 'number') {
          this.bubbleCountingRatio = Number(row.fbaJob.bubbleCountingRatio)
        } else {
          this.bubbleCountingRatio = 6000.0
        }
      } else {
        if (row.bubbleCountingRatio || typeof row.bubbleCountingRatio === 'number') {
          this.bubbleCountingRatio = Number(row.bubbleCountingRatio)
        } else {
          this.bubbleCountingRatio = 6000.0
        }
      }
      loadFbaExportWarehouseInRelated(params).then(res => {
        const warehouseIn = new WarehouseIn().fillDefaultValue().getData()
        const items = res.data
        if (items.warehouseIn) {
          for (const key in items.warehouseIn) {
            if (typeof warehouseIn[key] === 'object') {
              continue
            }
            warehouseIn[key] = items.warehouseIn[key]
          }
        }
        for (const key in items) {
          if (key === 'warehouseIn') {
            continue
          }
          warehouseIn[key] = items[key] || null
        }
        this.form = warehouseIn
        this.initWarehouse()
      })
    },
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
      switch (this.source) {
        case 'fbaSea':
          this.editPermission = this.$checkPermission(['button_FBABookingNew_fbaSeaEditGoodsDetailTab'])
          break
        case 'fbaAir':
          this.editPermission = this.$checkPermission(['button_FBAAeBooking_fbaAirEditGoodsDetailTab'])
          break
        case 'fbaRailway':
          this.editPermission = this.$checkPermission(['button_FBARailwayExport_fbaRailEditGoodsDetailTab'])
          break
      }
    },
    async onShow(row, isRefresh) {
      this.ready = false
      this.jobUuid = row.uuid
      if (row.fbaPallets) { // 托盘数量=打托信息页签维护的托盘数量
        row.palletSum = row.fbaPallets.length || 0
      }
      if (!isRefresh) {
        return
      }
      if (this.fbaLob) { // 根据业务货物国外仓数据
        this.job = row
        if (this.source === 'fbaAir') {
          this.mawbDoc = new AirCargoDoc().fillDefaultValue().getData()
          if (this.job) {
            this.mawbDoc = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
          }
        }
        this.getWarehouse(row)
      } else {
        this.form = row // row 是入库单
        this.initWarehouse()
      }
    },
    // 初始化国外仓相关数据
    initWarehouse() {
      this.calcEstJmt(true)
      this.calcActJmt(true)
      this.genSummaryGoodsDetailList()
      this.genSummaryJobGoodsDetailList()
      this.jobKeyOld = this.form.jobKey
      this.delWarehouseInDetailKeys = []
      this.delWarehouseInDetailKeysEst = []
      // 清空选中背景色
      if (this.detailList.gridApiEst) this.detailList.gridApiEst.clearFocusedCell()
      if (this.detailList.gridApi) this.detailList.gridApi.clearFocusedCell()
      this.ready = true
    },
    downLoadDetail() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsDetail.xlsx', 'fba')
    },
    downLoadSummary() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsSummary.xlsx', 'fba')
    },
    // 上传成功
    async uploadOrderSuccess(res, file, fileList) {
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
      this.$emit('reload')
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 批量导入：货物信息导入、下载模版
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.GoodsInformationImport'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownloadTemplate'):
          this.downloadTemplate()
          break
      }
    },
    // 计费重量计算相关变量变更
    chargeWeightRelateVarChange() {
      if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
        this.calcSingleVolumetricWeightAndChargeWeight(this.form.fbaJobGoods, true)
        this.calcEstJmt()
        this.genSummaryJobGoodsDetailList()
      } else {
        this.calcEstVolumetricAndChargeWeight()
      }
      if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
        this.calcSingleVolumetricWeightAndChargeWeight(this.form.warehouseInDetailList, false)
        this.calcActJmt(false, true)
        this.genSummaryGoodsDetailList()
      } else {
        this.calcActVolumetricAndChargeWeight()
      }
    },
    // 计算货物单箱材积和计费重量
    calcSingleVolumetricWeightAndChargeWeight(goods, est) {
      for (const item of goods) {
        let volumetricWeight = 0.0
        let chargeWeight = 0.0
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.job.fbaJob.chargingMethod) === 0) {
            volumetricWeight = ((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (item.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: item,
          fbaChannel: this.job.fbaChannel,
          chargingMethod: this.job.fbaJob.chargingMethod,
          fbaQuotation: this.job.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.job.fbaJob.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
        item.volumetricWeight = volumetricWeight
        item.chargeWeight = chargeWeight
      }
      if (est) {
        this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
      } else {
        this.detailList.goodGridOptions.api.refreshCells({ force: true })
      }
    },
    // 刷新费用
    async refreshCharge() {
      let authorizationValue = null
      let customers = []
      // 查找对应运价级别的客户
      for (const e of this.job.fbaQuotation.customerPriceList) {
        const item = { anyInteger: e.quotationObject }
        await searchCustomerPrice(item).then(res => {
          const result = res.data || []
          if (customers && customers.length > 0) {
            customers.concat(result)
          } else {
            customers = result
          }
        })
      }
      if (customers && customers.length > 0) {
        for (const customer of customers) {
          if (Number(this.job.customerId) === Number(customer.CMP_IDX)) {
            authorizationValue = customer.AUTHORIZATION_VALUE
            break
          }
        }
      }
      if (authorizationValue) {
        const params = {
          fbaChannel: this.job.fbaChannel,
          fbaQuotation: this.job.fbaQuotation,
          quantity: this.form.quantitySum,
          weight: this.form.weightSum,
          cubage: this.form.cubageSum,
          volumetricWeight: this.form.volumetricWeightAct,
          chargeWeight: Number(this.form.chargeWeightAct),
          warehouseCode: this.job.fbaJob.warehouseCode,
          authorizationValue: authorizationValue
        }
        const fbaChargeInfo = FbaQuotationUtil.getFbaChargeInfo(params)
        const fbaAdditionalChargeInfo = FbaQuotationUtil.getFbaAdditionalChargeInfo(params)
        if (this.job.charges && this.job.charges.length > 0) {
          let matchCharge = false
          const chargeList = []
          let matchAdditionalCharge = false
          const additionalChargeList = []
          for (const item of this.job.charges) {
            if (fbaChargeInfo) {
              const chargeItemIdSe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '海运费', 'itemId')
              const chargeItemIdAe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '空运费', 'itemId')
              const chargeItemIdRe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '运费', 'itemId')
              if (item.chargeItemId === chargeItemIdSe || item.chargeItemId === chargeItemIdAe || item.chargeItemId === chargeItemIdRe) {
                matchCharge = true
                chargeList.push(item)
              }
            }
            if (fbaAdditionalChargeInfo) {
              const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
              const matchList = chargeItemList.filter(p => (item.chargeItemId === p.itemId) && p.surcharge)
              if (matchList && matchList.length > 0) {
                matchAdditionalCharge = true
                additionalChargeList.push(item)
              }
            }
          }
          if (matchCharge) {
            this.updateCharge(fbaChargeInfo, chargeList)
          } else {
            await this.createCharge(fbaChargeInfo)
          }
          if (matchAdditionalCharge) {
            this.updateCharge(fbaAdditionalChargeInfo, additionalChargeList)
          } else {
            await this.createCharge(fbaAdditionalChargeInfo)
          }
        } else {
          if (fbaChargeInfo) {
            await this.createCharge(fbaChargeInfo)
          }
          if (fbaAdditionalChargeInfo) {
            await this.createCharge(fbaAdditionalChargeInfo)
          }
        }
      }
    },
    // 更新费用
    updateCharge(fbaChargeInfo, chargeList) {
      for (const item of chargeList) {
        if (!item.confirmBillUuid &&
            !item.invoiceUuid && !item.billingUuid && !item.billingPaymentUuid &&
            !item.verifiedAmount && !item.paidOff && item.chargeState === 0 &&
            ((item.receivable && this.job.receivableChargeLockedStatus === 0) || (!item.receivable && this.job.payableChargeLockedStatus === 0))) {
          if (fbaChargeInfo) {
            item.chargeItemId = fbaChargeInfo.chargeItemId
            item.currency = fbaChargeInfo.currency
            item.quantity = fbaChargeInfo.quantity
            item.unitRate = fbaChargeInfo.unitRate
            item.amount = fbaChargeInfo.amount
            item.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
            item.measure = fbaChargeInfo.measure
            item.accountId = this.job.customerId
            ChargeUtils.calculateTax(item, item.quantity * item.unitRate, item.taxRate, true)
            ChargeUtils.getChargeisOverseaNotControlledByConfig(item)
          }
        }
      }
      if (this.job.api) {
        this.job.api.refreshCells({ force: true })
      }
    },
    // 新增费用
    async createCharge(fbaChargeInfo) {
      if (fbaChargeInfo) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.chargeItemId = fbaChargeInfo.chargeItemId
        charge.currency = fbaChargeInfo.currency
        charge.quantity = fbaChargeInfo.quantity
        charge.unitRate = fbaChargeInfo.unitRate
        charge.amount = fbaChargeInfo.amount
        charge.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
        charge.measure = fbaChargeInfo.measure
        charge.accountId = this.job.customerId
        await BookingUtil.getNewCharge(charge, this.job, true)
        await ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        this.context.reloadCharge = true
      }
    },
    // 生成委托汇总数据
    genSummaryJobGoodsDetailList() {
      this.doGenerate('est')
    },
    // 生成实际汇总数据
    genSummaryGoodsDetailList() {
      this.doGenerate('act')
    },
    // 生成汇总数据
    doGenerate(type) {
      // key为相同合并条件json
      const sameGoods = {}
      const result = []
      const keys = []
      const sourceData = type === 'act' ? this.form.warehouseInDetailList : this.form.fbaJobGoods
      for (const item of sourceData) {
        const obj = {
          boxSeqLen: item.containerNo.substring(item.shipmentId.length).length,
          shipmentId: item.shipmentId,
          referenceId: item.referenceId,
          singleBoxWeight: this.$numeral(item.singleBoxWeight).format('0'),
          boxLength: this.$numeral(item.boxLength).format('0.000'),
          boxWidth: this.$numeral(item.boxWidth).format('0.000'),
          boxHeight: this.$numeral(item.boxHeight).format('0.000'),
          cargoEnglishName: item.cargoEnglishName,
          cargoChineseName: item.cargoChineseName
        }
        const key = JSON.stringify(obj)
        const currentSeq = Number(item.containerNo.substring(item.shipmentId.length))
        // 没有匹配到key则为新的一条汇总数据
        if (!sameGoods[key]) {
          keys.push(key)
          sameGoods[key] = { key: key, beginSeq: currentSeq, endSeq: currentSeq, ...item }
          sameGoods[key].boxesNumber = Number(item.boxesNumber)
          sameGoods[key].weight = Number(item.weight)
          // 实际货物明细额外操作
          if (type === 'act') {
            sameGoods[key].palletContainerNum = item.palletUuid ? 1 : 0
            sameGoods[key].otherContainerNum = item.palletUuid ? 0 : 1
            // 把当前明细数据与汇总数据通过key建立关联关系，方便后续对汇总数据的操作同步至明细
            this.summaryAndDetailGoodsRel[key] = []
            this.summaryAndDetailGoodsRel[key].push(item)
          } else {
            this.summaryAndDetailGoodsRelEst[key] = []
            this.summaryAndDetailGoodsRelEst[key].push(item)
          }
          continue
        }
        const goods = sameGoods[key]
        // 计算汇总箱数和重量
        goods.boxesNumber += Number(item.boxesNumber)
        goods.weight += Number(item.weight)
        // 实际货物明细额外操作
        if (type === 'act') {
          if (item.palletUuid) {
            goods.palletContainerNum++
          } else {
            goods.otherContainerNum++
          }
          this.summaryAndDetailGoodsRel[key].push(item)
        } else {
          this.summaryAndDetailGoodsRelEst[key].push(item)
        }
        // 当前明细已存在汇总数据则比较并设置箱货编号起始和结束序号
        if (currentSeq < goods.beginSeq) {
          // 如果当前明细箱货编号作为起始编号则同时设置containerNo 方便最后生成汇总数据的箱货编号
          goods.beginSeq = currentSeq
          goods.containerNo = item.containerNo
        }
        if (currentSeq > goods.endSeq) {
          goods.endSeq = currentSeq
        }
      }
      // 生成汇总数据的箱货编号
      keys.forEach(key => {
        const goods = sameGoods[key]
        if (goods.beginSeq !== goods.endSeq && !isNaN(goods.beginSeq) && !isNaN(goods.endSeq)) {
          goods.containerNo = goods.containerNo + '-' + goods.endSeq
        }
        result.push(goods)
      })
      if (type === 'act') {
        this.summaryGoodsDetailList = result
      } else {
        this.summaryJobGoodsDetailList = result
      }
    },
    // 加入实际货物
    addDetailHandler(estGoods) {
      const detail = new FbaWarehouseInDetail().fillDefaultValue().getData()
      if (estGoods) {
        estGoods.uuid = null
        Object.assign(detail, estGoods)
      }
      detail.warehouseInUuid = this.form.uuid
      detail.jobUuid = this.jobUuid
      detail.boxesNumber = 1
      detail.updated = true
      detail.tmpUuid = Math.random().toString(36).slice(3)
      this.form.warehouseInDetailList.push(detail)
      this.genSummaryGoodsDetailList()
      this.calcActJmt()
    },
    // 加入委托货物
    addDetailEstHandler() {
      const detail = new FbaWarehouseInDetail().fillDefaultValue().getData()
      detail.jobUuid = this.jobUuid
      detail.boxesNumber = 1
      detail.updated = true
      detail.tmpUuid = Math.random().toString(36).slice(3)
      this.form.fbaJobGoods.push(detail)
      this.calcEstJmt()
    },
    // 计算委托件毛体
    calcEstJmt(init = false) {
      // 委托
      this.form.quantityContract = 0
      this.form.weightContract = 0
      this.form.cubageContract = 0
      this.form.volumetricWeightContract = 0.0
      this.form.chargeWeightContract = 0.0
      const fbaJobGoods = this.form.fbaJobGoods || []
      let cubage = 0
      if (fbaJobGoods && fbaJobGoods.length > 0) {
        for (const item of fbaJobGoods) {
          if (item.boxesNumber) {
            this.form.quantityContract += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightContract += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)
            cubage += tempCubage
          }
        }
      }
      this.form.cubageContract = (cubage / 1000000).toFixed(3)
      // 材积
      if (this.bubbleCountingRatio > 0) {
        if (Number(this.job.fbaJob.chargingMethod) === 0) {
          this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
        } else {
          this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
        }
      }
      // 计费重量
      const params = {
        goods: fbaJobGoods,
        fbaQuotation: this.job.fbaQuotation,
        chargingMethod: this.job.fbaJob.chargingMethod,
        quantity: this.form.quantityContract,
        weight: this.form.weightContract,
        cubage: this.form.cubageContract,
        volumetricWeight: this.form.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
      if (!init) {
        this.job.quantityContract = Number(this.form.quantityContract)
        this.job.weightContract = Number(this.form.weightContract)
        this.job.cubageContract = Number(this.form.cubageContract)
      }
      if (init) {
        switch (this.source) {
          case 'fbaSea':
            if (this.job.chargeWeightContract && typeof this.job.chargeWeightContract === 'number') {
              this.form.chargeWeightContract = this.job.chargeWeightContract
            }
            break
          case 'fbaAir':
            if (this.job.chargeWeight && typeof this.job.chargeWeight === 'number') {
              this.form.chargeWeightContract = this.job.chargeWeight
            }
            break
          case 'fbaRailway':
            if (this.job.chargeWeightContract && typeof this.job.chargeWeightContract === 'number') {
              this.form.chargeWeightContract = this.job.chargeWeightContract
            }
            break
        }
      }
      if (!init) {
        switch (this.source) {
          case 'fbaSea':
            this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
            this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
            break
          case 'fbaAir':
            this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
            this.job.chargeWeight = Number(this.form.chargeWeightContract)
            this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
            this.job.quantityBooking = Number(this.job.quantityContract)
            this.job.weightBooking = Number(this.job.weightContract)
            this.job.cubageBooking = Number(this.job.cubageContract)
            this.job.chargeWeightBooking = Number(this.job.chargeWeight)
            this.job.volumetricWeightBooking = Number(this.job.volumetricWeightContract)
            break
          case 'fbaRailway':
            this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
            this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
            break
        }
      }
      this.form.weightContract = Number(this.form.weightContract).toFixed(2)
      this.form.cubageContract = Number(this.form.cubageContract).toFixed(3)
      this.form.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
    },
    // 计算预计材积和计费重量
    calcEstVolumetricAndChargeWeight() {
      const cubage = this.form.cubageContract * 1000000
      // 材积
      if (this.bubbleCountingRatio > 0) {
        if (Number(this.job.fbaJob.chargingMethod) === 0) {
          this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
        } else {
          this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
        }
      }
      // 计费重量
      const params = {
        goods: this.form.fbaJobGoods,
        fbaQuotation: this.job.fbaQuotation,
        chargingMethod: this.job.fbaJob.chargingMethod,
        quantity: this.form.quantityContract,
        weight: this.form.weightContract,
        cubage: this.form.cubageContract,
        volumetricWeight: this.form.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (this.form.quantityContract > 0 && this.form.weightContract > 0 && this.form.cubageContract > 0 && this.form.volumetricWeightContract > 0) {
        this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
      }
      switch (this.source) {
        case 'fbaSea':
          this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
          this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
          break
        case 'fbaAir':
          this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
          this.job.chargeWeight = Number(this.form.chargeWeightContract)
          this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
          this.job.chargeWeightBooking = Number(this.job.chargeWeight)
          this.job.volumetricWeightBooking = Number(this.job.volumetricWeightContract)
          break
        case 'fbaRailway':
          this.job.chargeWeightContract = Number(this.form.chargeWeightContract)
          this.job.volumetricWeightContract = Number(this.form.volumetricWeightContract)
          break
      }
      this.form.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
    },
    changeChargeWeightContract() {
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
      switch (this.source) {
        case 'fbaSea':
          this.job.chargeWeightContract = this.form.chargeWeightContract
          break
        case 'fbaAir':
          this.job.chargeWeight = this.form.chargeWeightContract
          this.job.chargeWeightBooking = this.form.chargeWeightContract
          break
        case 'fbaRailway':
          this.job.chargeWeightContract = this.form.chargeWeightContract
          break
      }
    },
    // 计算实际件毛体
    calcActJmt(init = false, notRefreshCharge = false) {
      // 实际
      const oldChargeWeightAct = this.form.chargeWeightAct
      this.form.quantitySum = 0
      this.form.weightSum = 0
      this.form.cubageSum = 0
      this.form.volumetricWeightAct = 0.0
      this.form.chargeWeightAct = 0.0
      const warehouseInDetailList = this.form.warehouseInDetailList || []
      let electric = false
      let magnetic = false
      let powdery = false
      let liquid = false
      let cubage = 0
      if (warehouseInDetailList && warehouseInDetailList.length > 0) {
        for (const item of warehouseInDetailList) {
          if (item.boxesNumber) {
            this.form.quantitySum += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightSum += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)
            cubage += tempCubage
          }
          if (!electric && item.electric) {
            electric = true
          }
          if (!magnetic && item.magnetic) {
            magnetic = true
          }
          if (!powdery && item.powdery) {
            powdery = true
          }
          if (!liquid && item.liquid) {
            liquid = true
          }
        }
      }
      this.form.cubageSum = (cubage / 1000000).toFixed(3)
      // 材积
      if (this.bubbleCountingRatio > 0) {
        if (Number(this.job.fbaJob.chargingMethod) === 0) {
          this.form.volumetricWeightAct = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
        } else {
          this.form.volumetricWeightAct = (this.form.weightSum / 1000).toFixed(3)
        }
      }
      // 计费重量
      const params = {
        goods: warehouseInDetailList,
        fbaQuotation: this.job.fbaQuotation,
        chargingMethod: this.job.fbaJob.chargingMethod,
        quantity: this.form.quantitySum,
        weight: this.form.weightSum,
        cubage: this.form.cubageSum,
        volumetricWeight: this.form.volumetricWeightAct
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      const refreshCharge = Number(Number(chargeWeight).toFixed(3)) !== Number(oldChargeWeightAct)
      this.form.chargeWeightAct = Number(chargeWeight).toFixed(3)
      if (!init) {
        this.job.quantityActual = Number(this.form.quantitySum)
        this.job.weightActual = Number(this.form.weightSum)
        this.job.cubageActual = Number(this.form.cubageSum)
        this.job.volumetricWeight = Number(this.form.volumetricWeightAct)
      }
      if (init) {
        switch (this.source) {
          case 'fbaSea':
            if (this.job.chargeWeight > 0 && typeof this.job.chargeWeight === 'number') {
              this.form.chargeWeightAct = this.job.chargeWeight
            }
            break
          case 'fbaAir':
            if (this.job.cWeight > 0 && typeof this.job.cWeight === 'number') {
              this.form.chargeWeightAct = this.job.cWeight
            }
            break
          case 'fbaRailway':
            if (this.job.chargeWeight > 0 && typeof this.job.chargeWeight === 'number') {
              this.form.chargeWeightAct = this.job.chargeWeight
            }
            break
        }
      }
      if (!init) {
        this.job.fbaJob.electric = electric
        this.job.fbaJob.magnetic = magnetic
        this.job.fbaJob.powdery = powdery
        this.job.fbaJob.liquid = liquid
        switch (this.source) {
          case 'fbaSea':
            this.job.chargeWeight = Number(this.form.chargeWeightAct)
            break
          case 'fbaAir':
            this.job.cWeight = Number(this.form.chargeWeightAct)
            this.mawbDoc.quantity = Number(this.job.quantityActual)
            this.mawbDoc.weight = Number(this.job.weightActual)
            this.mawbDoc.cubage = Number(this.job.cubageActual)
            this.mawbDoc.cWeight = Number(this.job.cWeight)
            this.mawbDoc.volumetricWeight = Number(this.job.volumetricWeight)
            break
          case 'fbaRailway':
            this.job.chargeWeight = Number(this.form.chargeWeightAct)
            break
        }
        if (!notRefreshCharge && refreshCharge) {
          this.changeChargeWeightAct()
        }
      }
      this.form.weightSum = Number(this.form.weightSum).toFixed(2)
      this.form.cubageSum = Number(this.form.cubageSum).toFixed(3)
      this.form.volumetricWeightAct = Number(this.form.volumetricWeightAct).toFixed(3)
      this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
    },
    // 计算实际材积和计费重量
    calcActVolumetricAndChargeWeight() {
      const cubage = this.form.cubageSum * 1000000
      // 材积
      if (this.bubbleCountingRatio > 0) {
        if (Number(this.job.fbaJob.chargingMethod) === 0) {
          this.form.volumetricWeightAct = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
        } else {
          this.form.volumetricWeightAct = (this.form.weightSum / 1000).toFixed(3)
        }
      }
      // 计费重量
      const params = {
        goods: this.form.warehouseInDetailList,
        fbaQuotation: this.job.fbaQuotation,
        chargingMethod: this.job.fbaJob.chargingMethod,
        quantity: this.form.quantitySum,
        weight: this.form.weightSum,
        cubage: this.form.cubageSum,
        volumetricWeight: this.form.volumetricWeightAct
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (this.form.quantitySum > 0 && this.form.weightSum > 0 && this.form.cubageSum > 0 && this.form.volumetricWeightAct > 0) {
        this.form.chargeWeightAct = Number(chargeWeight).toFixed(3)
      } else {
        this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
      }
      this.job.volumetricWeight = Number(this.form.volumetricWeightAct)
      switch (this.source) {
        case 'fbaSea':
          this.job.chargeWeight = Number(this.form.chargeWeightAct)
          break
        case 'fbaAir':
          this.job.cWeight = Number(this.form.chargeWeightAct)
          this.mawbDoc.cWeight = Number(this.job.cWeight)
          this.mawbDoc.volumetricWeight = Number(this.job.volumetricWeight)
          break
        case 'fbaRailway':
          this.job.chargeWeight = Number(this.form.chargeWeightAct)
          break
      }
    },
    async changeChargeWeightAct() {
      this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
      switch (this.source) {
        case 'fbaSea':
          this.job.chargeWeight = this.form.chargeWeightAct
          break
        case 'fbaAir':
          this.job.cWeight = this.form.chargeWeightAct
          this.mawbDoc.cWeight = this.form.chargeWeightAct
          break
        case 'fbaRailway':
          this.job.chargeWeight = this.form.chargeWeightAct
          break
      }
      if (this.job.customerId && this.job.fbaJob.serviceChannel && this.form.chargeWeightAct && this.form.chargeWeightAct > 0) {
        await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    // 清空实际
    clearData() {
      this.$confirm(this.$t('Warehouse.deleteTheDetailRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        // 清空明细数据
        if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
          this.form.warehouseInDetailList.forEach(item => {
            this.delWarehouseInDetailKeys.push(item.uuid)
          })
          this.form.warehouseInDetailList = []
        }
        // 清空汇总数据
        this.summaryGoodsDetailList = []
        this.form.quantitySum = 0
        this.form.weightSum = Number(0).toFixed(2)
        this.form.cubageSum = Number(0).toFixed(3)
        this.form.volumetricWeightAct = Number(0).toFixed(3)
        this.form.chargeWeightAct = Number(0).toFixed(3)
        this.calcActJmt()
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 清空委托
    clearDataEst() {
      this.$confirm(this.$t('Warehouse.deleteTheDetailRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        // 清空明细数据
        if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
          this.form.fbaJobGoods.forEach(item => {
            this.delWarehouseInDetailKeysEst.push(item.uuid)
          })
          this.form.fbaJobGoods = []
        }
        // 清空汇总数据
        this.summaryJobGoodsDetailList = []
        this.form.quantityContract = 0
        this.form.weightContract = Number(0).toFixed(2)
        this.form.cubageContract = Number(0).toFixed(3)
        this.form.volumetricWeightContract = Number(0).toFixed(3)
        this.form.chargeWeightContract = Number(0).toFixed(3)
        this.calcEstJmt()
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 删除货物
    delDetailHandler() {
      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = []
        const tmpUuids = []
        getGridSelected(this.detailList.goodGridOptions).forEach(rowData => {
          if (this.goodsViewSummary) {
            this.summaryAndDetailGoodsRel[rowData.key].forEach(detailGoods => {
              detailGoods.uuid ? uuids.push(detailGoods.uuid) : tmpUuids.push(detailGoods.tmpUuid)
            })
            const index = this.summaryGoodsDetailList.findIndex(item => item.key === rowData.key)
            if (index > -1) {
              this.summaryGoodsDetailList.splice(index, 1)
            }
          } else {
            rowData.uuid ? uuids.push(rowData.uuid) : tmpUuids.push(rowData.tmpUuid)
          }
        })
        this.deleteGoodsDetail(uuids)
        this.deleteTmpGoodsDetail(tmpUuids)
        this.calcActJmt()
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 删除货物委托
    delDetailEstHandler() {
      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = []
        const tmpUuids = []
        getGridSelected(this.detailList.goodGridOptionsEst).forEach(rowData => {
          if (this.jobGoodsViewSummary) {
            this.summaryAndDetailGoodsRelEst[rowData.key].forEach(detailGoods => {
              detailGoods.uuid ? uuids.push(detailGoods.uuid) : tmpUuids.push(detailGoods.tmpUuid)
            })
            const index = this.summaryJobGoodsDetailList.findIndex(item => item.key === rowData.key)
            if (index > -1) {
              this.summaryJobGoodsDetailList.splice(index, 1)
            }
          } else {
            rowData.uuid ? uuids.push(rowData.uuid) : tmpUuids.push(rowData.tmpUuid)
          }
        })
        this.deleteGoodsDetail(uuids, true)
        this.deleteTmpGoodsDetail(tmpUuids, true)
        this.calcEstJmt()
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 删除已入库明细箱货信息
    deleteGoodsDetail(uuids, est = false) {
      const keys = est ? this.delWarehouseInDetailKeysEst : this.delWarehouseInDetailKeys
      const detailList = est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
      for (const uuid of uuids) {
        if (uuid && !keys.includes(uuid)) {
          keys.push(uuid)
        }
        const index = detailList.findIndex(item => item.uuid === uuid)
        if (index > -1) {
          detailList.splice(index, 1)
        }
      }
      if (est) {
        this.genSummaryJobGoodsDetailList()
      } else {
        this.genSummaryGoodsDetailList()
      }
    },
    // 删除临时明细箱货信息
    deleteTmpGoodsDetail(uuids, est = false) {
      const detailList = est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
      for (const uuid of uuids) {
        const index = detailList.findIndex(item => item.tmpUuid === uuid)
        if (index > -1) {
          detailList.splice(index, 1)
        }
      }
      if (est) {
        this.genSummaryJobGoodsDetailList()
      } else {
        this.genSummaryGoodsDetailList()
      }
    },
    // 按客户数据拣货
    async pickingGoods() {
      if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
        if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
          await this.$confirm(this.$t('Warehouse.overwriteTheDetailRecord'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(() => {
            // 清空明细数据
            if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
              this.form.warehouseInDetailList.forEach(item => {
                this.delWarehouseInDetailKeys.push(item.uuid)
              })
              this.form.warehouseInDetailList = []
            }
            // 清空汇总数据
            this.summaryGoodsDetailList = []
          }).catch(() => {
            return Promise.reject(this.$t('Message.DeletionCancelled'))
          })
        }
        this.form.fbaJobGoods.forEach(goods => {
          this.addDetailHandler(goods)
        })
      }
      this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
    },
    // 批量维护
    batchMaintenance() {
      this.batchMaintenanceDialog.est = false
      this.batchMaintenanceDialog.visible = true
    },
    // 批量维护委托
    batchMaintenanceEst() {
      this.batchMaintenanceDialog.est = true
      this.batchMaintenanceDialog.visible = true
    },
    // 核单
    onCheckList() {
      if (this.form.warehouseInDetailList && this.form.warehouseInDetailList[0].checklistStatus) {
        this.$message.warning(this.$t('Warehouse.alreadyChecklist'))
        return
      }
      this.checklist.checklistTime = ''
      this.checklist.comments = ''
      this.checklist.checklistStatus = 1
      this.checklist.visible = true
    },
    // 确定核单
    toChecklist() {
      const isWeigh = this.checkActGoodsDetail()
      if (!isWeigh) {
        // 选择的数据中包含未称重数据，请检查。
        this.$message.warning(this.$t('Warehouse.ChecklistTip'))
        return
      }
      if (!this.checklist.checklistTime) {
        this.$message.warning(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.checklistStatus && Number(this.checklist.checklistStatus) !== 0) {
        this.$message.warning(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.comments && Number(this.checklist.checklistStatus) === 0) {
        this.$message.warning(this.$t('Warehouse.HandlingOpinions') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const obj = {}
      obj.keys = [this.jobUuid]
      obj.anyDate = this.checklist.checklistTime
      obj.anyInteger = this.checklist.checklistStatus
      obj.anyStr1 = this.checklist.comments // 处理意见
      this.loading = getLoading()
      fbaSeaExportChecklist(obj).then(res => {
        if (res.data > 0) {
          this.$emit('reload')
          this.$message.success(this.$t('Warehouse.Checklist') + this.$t('Message.Success'))
        }
      }).finally(() => {
        this.checklist.visible = false
        this.loading.close()
      })
    },
    checkActGoodsDetail() {
      let isWeigh = true
      // 实际货物明细条数
      if (isWeigh && !this.form.warehouseInDetailList && this.form.warehouseInDetailList.length <= 0) {
        isWeigh = false
      }
      // 实际件数
      if (isWeigh && !this.form.quantitySum || this.form.quantitySum <= 0) {
        isWeigh = false
      }
      // 实际重量
      if (isWeigh && !this.form.weightSum || this.form.weightSum <= 0) {
        isWeigh = false
      }
      // 实际体积
      if (isWeigh && !this.form.cubageSum || this.form.cubageSum <= 0) {
        isWeigh = false
      }
      return isWeigh
    },
    onSummaryContainerNoCellFocused(event, est = false) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = est ? this.detailList.goodGridOptionsEst.api.getDisplayedRowAtIndex(event.rowIndex).data : this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.boxesNumber = data.boxesNumber
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.key
          this.containerNoEditor.containerNo = data.containerNo
          this.containerNoEditor.est = est
          this.containerNoEditor.source = est ? this.jobGoodsViewType : this.goodsViewType
          this.containerNoEditor.detailList = est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
        }
      }
    },
    onDetailContainerNoCellFocused(event, est = false) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = est ? this.detailList.goodGridOptionsEst.api.getDisplayedRowAtIndex(event.rowIndex).data : this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.uuid ? data.uuid : data.tmpUuid
          this.containerNoEditor.containerNo = data.containerNo
          this.containerNoEditor.est = est
          this.containerNoEditor.source = est ? this.jobGoodsViewType : this.goodsViewType
          this.containerNoEditor.detailList = est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
        }
      }
    },
    allowContainerNoCellEdit(data) {
      if (!data.shipmentId) {
        this.$message.warning(this.$t('Warehouse.shipmentIdNotNull'))
        return false
      }
      return true
    },
    // 列编辑
    async onCellChange(params, est = false) {
      const field = params.colDef.field
      const goods = params.data
      let volumetricWeight = 0.0
      let chargeWeight = 0.0
      if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.job.fbaJob.chargingMethod) === 0) {
            volumetricWeight = ((Number(goods.boxLength) * Number(goods.boxWidth) * Number(goods.boxHeight) * Number(goods.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (goods.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: goods,
          fbaChannel: this.job.fbaChannel,
          chargingMethod: this.job.fbaJob.chargingMethod,
          fbaQuotation: this.job.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.job.fbaJob.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
      }
      if (est) {
        const internal = this.detailList.goodGridOptionsEst.api.getSelectedRows()
        if (this.jobGoodsViewSummary) {
          // 编辑汇总数据 同步至本条汇总数据的所有明细数据
          const detailsOfSummaryGoods = this.summaryAndDetailGoodsRelEst[goods.key]
          detailsOfSummaryGoods.forEach(e => {
            if (field !== 'shipmentId' || !e.containerNo) {
              e[field] = goods[field]
            }
            if (field === 'singleBoxWeight') {
              e.weight = e.singleBoxWeight * e.boxesNumber
            }
            if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
              e.volumetricWeight = volumetricWeight
              e.chargeWeight = chargeWeight
            }
            e.updated = true
          })
          if (field === 'singleBoxWeight') {
            goods.weight = goods.singleBoxWeight * goods.boxesNumber
            this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            goods.volumetricWeight = volumetricWeight
            goods.chargeWeight = chargeWeight
            this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
          }
          if (field === 'shipmentId') {
            const containerNo = goods.containerNo
            if (containerNo) {
              await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                type: 'warning'
              }).then(() => {
                // 校验containerNo是否重复
                for (const detailGoods of detailsOfSummaryGoods) {
                  const detailContainerNo = detailGoods.containerNo
                  if (detailContainerNo) {
                    const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                    if (this.containerNoDuplicate(newDetailContainerNo, true)) {
                      goods.shipmentId = params.oldValue
                      this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
                      return
                    }
                  }
                }
                for (const detailGoods of detailsOfSummaryGoods) {
                  const detailContainerNo = detailGoods.containerNo
                  if (detailContainerNo) {
                    const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                    detailGoods.shipmentId = goods.shipmentId
                    detailGoods.containerNo = newDetailContainerNo
                  }
                }
                goods.containerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
              }).catch(() => {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
                return Promise.reject(this.$t('Message.EditCancelled'))
              })
            }
          }
        } else {
          // 编辑单货箱重量同步重量
          if (field === 'singleBoxWeight') {
            goods.weight = goods.singleBoxWeight * goods.boxesNumber
            this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
          }
          // 编辑shipmentId刷新货箱编号
          if (field === 'shipmentId') {
            const containerNo = goods.containerNo
            if (containerNo) {
              await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                type: 'warning'
              }).then(() => {
                const newContainerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                // 校验containerNo是否重复
                if (this.containerNoDuplicate(newContainerNo, true)) {
                  goods.shipmentId = params.oldValue
                  this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
                  return
                }
                goods.containerNo = newContainerNo
                this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
              }).catch(() => {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
                return Promise.reject(this.$t('Message.EditCancelled'))
              })
            }
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            goods.volumetricWeight = volumetricWeight
            goods.chargeWeight = chargeWeight
            this.detailList.goodGridOptionsEst.api.updateRowData({ update: internal })
          }
          goods.updated = true
          this.genSummaryJobGoodsDetailList()
        }
        this.calcEstJmt()
      } else {
        const internal = this.detailList.goodGridOptions.api.getSelectedRows()
        if (this.goodsViewSummary) {
          // 编辑汇总数据 同步至本条汇总数据的所有明细数据
          const detailsOfSummaryGoods = this.summaryAndDetailGoodsRel[goods.key]
          detailsOfSummaryGoods.forEach(e => {
            if (field !== 'shipmentId' || !e.containerNo) {
              e[field] = goods[field]
            }
            if (field === 'singleBoxWeight') {
              e.weight = e.singleBoxWeight * e.boxesNumber
            }
            if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
              e.volumetricWeight = volumetricWeight
              e.chargeWeight = chargeWeight
            }
            e.updated = true
          })
          if (field === 'singleBoxWeight') {
            goods.weight = goods.singleBoxWeight * goods.boxesNumber
            this.detailList.goodGridOptions.api.updateRowData({ update: internal })
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            goods.volumetricWeight = volumetricWeight
            goods.chargeWeight = chargeWeight
            this.detailList.goodGridOptions.api.updateRowData({ update: internal })
          }
          if (field === 'shipmentId') {
            const containerNo = goods.containerNo
            if (containerNo) {
              await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                type: 'warning'
              }).then(() => {
                // 校验containerNo是否重复
                for (const detailGoods of detailsOfSummaryGoods) {
                  const detailContainerNo = detailGoods.containerNo
                  if (detailContainerNo) {
                    const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                    if (this.containerNoDuplicate(newDetailContainerNo)) {
                      goods.shipmentId = params.oldValue
                      this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                      return
                    }
                  }
                }
                for (const detailGoods of detailsOfSummaryGoods) {
                  const detailContainerNo = detailGoods.containerNo
                  if (detailContainerNo) {
                    const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                    detailGoods.shipmentId = goods.shipmentId
                    detailGoods.containerNo = newDetailContainerNo
                  }
                }
                goods.containerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              }).catch(() => {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                return Promise.reject(this.$t('Message.EditCancelled'))
              })
            }
          }
        } else {
          // 编辑单货箱重量同步重量
          if (field === 'singleBoxWeight') {
            goods.weight = goods.singleBoxWeight * goods.boxesNumber
            this.detailList.goodGridOptions.api.updateRowData({ update: internal })
          }
          // 编辑shipmentId刷新货箱编号
          if (field === 'shipmentId') {
            const containerNo = goods.containerNo
            if (containerNo) {
              await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                type: 'warning'
              }).then(() => {
                const newContainerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                // 校验containerNo是否重复
                if (this.containerNoDuplicate(newContainerNo)) {
                  goods.shipmentId = params.oldValue
                  this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                  return
                }
                goods.containerNo = newContainerNo
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              }).catch(() => {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                return Promise.reject(this.$t('Message.EditCancelled'))
              })
            }
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            goods.volumetricWeight = volumetricWeight
            goods.chargeWeight = chargeWeight
            this.detailList.goodGridOptions.api.updateRowData({ update: internal })
          }
          goods.updated = true
          this.genSummaryGoodsDetailList()
        }
        this.calcActJmt()
      }
    },
    // 验证containerNo是否重复
    containerNoDuplicate(containerNo, est = false) {
      const detailList = est ? this.form.fbaJobGoods : this.form.warehouseInDetailList
      for (const detail of detailList) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      return false
    },
    // 检查委托和实际 箱数、单货箱重量、货箱长度、货箱宽度、货箱高度、托盘编号是否一致
    compareEstWarehouseInField(fieldName, current, targetList) {
      for (const e of targetList) {
        const sameItem = e.containerNo === current.containerNo
        if (sameItem) {
          let currentFieldValue = current[fieldName]
          let targetFieldValue = e[fieldName]
          if (fieldName === 'boxesNumber') {
            currentFieldValue = this.$numeral(currentFieldValue).format('0')
            targetFieldValue = this.$numeral(targetFieldValue).format('0')
          }
          if (fieldName === 'singleBoxWeight' || fieldName === 'boxLength' || fieldName === 'boxWidth' || fieldName === 'boxHeight' || fieldName === 'chargeWeight' || fieldName === 'volumetricWeight') {
            currentFieldValue = this.$numeral(currentFieldValue).format('0.000')
            targetFieldValue = this.$numeral(targetFieldValue).format('0.000')
          }
          if (targetFieldValue === currentFieldValue) {
            return { color: 'black' }
          }
        }
      }
      return { color: 'red' }
    },
    getSubmitData() {
      this.checkSubmitData()
      const updatedWarehouseInDetailList = this.form.warehouseInDetailList.filter(p => p.updated)
      const warehouseInDetailList = [...updatedWarehouseInDetailList]
      const updatedFbaJobGoodsList = this.form.fbaJobGoods.filter(p => p.updated)
      const fbaJobGoodsDetailList = [...updatedFbaJobGoodsList]
      return {
        job: this.job,
        fbaJobGoodsDetailList,
        warehouseInDetailList,
        delFbaJobGoodsDetailKeys: this.delWarehouseInDetailKeysEst,
        delWarehouseInDetailKeys: this.delWarehouseInDetailKeys
      }
    },
    checkSubmitData() {
      // 检查委托
      for (const detail of this.form.fbaJobGoods) {
        if (!detail.containerNo) {
          throw new TabError(this.$t('Warehouse.saveCheckContainerNoFail'), 'fbaGoodsDetail')
        }
        if (!detail.shipmentId) {
          throw new TabError(this.$t('Warehouse.saveCheckShipmentIdFail'), 'fbaGoodsDetail')
        }
        if (!detail.singleBoxWeight) {
          throw new TabError(this.$t('Warehouse.saveCheckQuantityFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxLength) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxLengthFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxWidth) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxWidthFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxHeight) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxHeightFail'), 'fbaGoodsDetail')
        }
        if (!detail.cargoChineseName) {
          throw new TabError(this.$t('Warehouse.saveCheckChineseCargoNameFail'), 'fbaGoodsDetail')
        }
        if (!detail.cargoEnglishName) {
          throw new TabError(this.$t('Warehouse.saveCheckEnglishCargoNameFail'), 'fbaGoodsDetail')
        }
      }
      // 检查实际
      for (const detail of this.form.warehouseInDetailList) {
        if (!detail.containerNo) {
          throw new TabError(this.$t('Warehouse.saveCheckContainerNoFail'), 'fbaGoodsDetail')
        }
        if (!detail.shipmentId) {
          throw new TabError(this.$t('Warehouse.saveCheckShipmentIdFail'), 'fbaGoodsDetail')
        }
        if (!detail.singleBoxWeight) {
          throw new TabError(this.$t('Warehouse.saveCheckQuantityFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxLength) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxLengthFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxWidth) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxWidthFail'), 'fbaGoodsDetail')
        }
        if (!detail.boxHeight) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxHeightFail'), 'fbaGoodsDetail')
        }
        if (!detail.cargoChineseName) {
          throw new TabError(this.$t('Warehouse.saveCheckChineseCargoNameFail'), 'fbaGoodsDetail')
        }
        if (!detail.cargoEnglishName) {
          throw new TabError(this.$t('Warehouse.saveCheckEnglishCargoNameFail'), 'fbaGoodsDetail')
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.blueStyle {
  color: $--color-primary-light-1;
}
</style>
